import UserBids from "components/bids";
import SharedBids from "components/sharedbids";
import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import policy from "policies";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Form from "./form";
import Show from "./show";

export default class Bids extends Component {
    componentWillUnmount() {
        this.props.resetPaginationPage("bids");
    }

    render() {
        const { match, location, switchMap, history, roles } = this.props;
        let back = () => history.push(match.path);
        const bMatch = match;
        const isOnlyExtendedViewer = policy("user", { user: { roles } }).isOnlyExtendedViewer();
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route
                        exact
                        path={bMatch.path}
                        render={(props) => {
                            const { carId, trailerId } = paramsObject(props.location.search);
                            return (
                                <UserBids
                                    {...props}
                                    title="Список заявок"
                                    nofilter
                                    createBtnText="Создать заявку"
                                    switchMap={switchMap}
                                    carId={carId}
                                    trailerId={trailerId}
                                />
                            );
                        }}
                    />
                    <Route
                        exact
                        path={`${bMatch.path}/shared`}
                        render={(props) => (
                            <SharedBids {...props} title="Список заявок" nofilter switchMap={switchMap} back={back} />
                        )}
                    />
                    <Route
                        exact
                        path={`${bMatch.path}/new`}
                        render={(props) => {
                            if (isOnlyExtendedViewer) {
                                return <Redirect to={bMatch.path} />;
                            }
                            const { type, carId, backPath, distributionBidId, matchingId, cargorunId } = paramsObject(
                                props.location.search,
                            );
                            if (backPath === "planning") {
                                back = () => history.push(paths.planning);
                            }
                            const componentProps = {
                                ...props,
                                back,
                                switchMap,
                                carId,
                                distributionBidId,
                                matchingId,
                                cargorunId,
                                isPublic: type && type === "public",
                                action: "new",
                                title: "Новая заявка",
                            };
                            return <Form {...componentProps} />;
                        }}
                    />
                    <Route
                        path={`${bMatch.path}/edit/:id`}
                        render={(props) => {
                            if (isOnlyExtendedViewer) {
                                return <Redirect to={bMatch.path} />;
                            }
                            const { id } = props.match.params;
                            back = () => history.push(paths.bidShow("bid", id));
                            const { editRoute, confirmRoute, isCopy } = paramsObject(props.location.search);
                            const componentProps = {
                                ...props,
                                editRoute,
                                confirmRoute,
                                switchMap,
                                back,
                                isCopy: isCopy === "true",
                                isPublic: false,
                                title: "Редактировать заявку",
                                action: "edit",
                            };
                            return <Form {...componentProps} />;
                        }}
                    />
                    <Route
                        path={`${bMatch.path}/:type/:id`}
                        render={(props) => {
                            const { id, type } = props.match.params;
                            const { history } = props;
                            const baseUrl = `${bMatch.path}/${type}/${id}`;
                            const { from, chatId, bidId } = paramsObject(props.location.search);
                            let backAction = back;
                            switch (from) {
                                case "chat":
                                    if (chatId) {
                                        backAction = () => history.push(paths.chatsShow(chatId));
                                    }
                                    break;
                                case "planning":
                                    backAction = () => history.push(paths.planning);
                                    break;
                                case "bid":
                                    backAction = () => history.push(paths.bidShow("bid", bidId));
                                    break;
                            }
                            if (type === "bid") {
                                return (
                                    <Show
                                        key={type}
                                        {...props}
                                        baseUrl={baseUrl}
                                        id={id}
                                        back={backAction}
                                        type={type}
                                    />
                                );
                            } else {
                                return (
                                    <Show
                                        key={type}
                                        {...props}
                                        baseUrl={baseUrl}
                                        id={id}
                                        back={backAction}
                                        type={type}
                                    />
                                );
                            }
                        }}
                    />
                </Switch>
            </div>
        );
    }
}
